<template>
    <div>
        <template v-if="isStatic">
            <div class="form-control form-control--static" :class="className">
                {{ item.profile.firstname }} {{ item.profile.lastname }}
            </div>
        </template>
        <template v-else>
            <select :id="id" :name="name" class="form-control form-control--select" :class="className" :tabindex="tabindex" @change="onChangeItem">
                <template v-if="hasPlaceholder">
                    <option value="0" :selected="isSelectedItem(0)">{{ placeholder }}</option>
                </template>
                <template v-for="item in items">
                    <option :value="item.id" :selected="isSelectedItem(item.id)">{{ item.profile.firstname }} {{ item.profile.lastname }}</option>
                </template>
            </select>
        </template>
    </div>
</template>

<script>
    export default {
        props : {
            id : {
                type : String,
                default : 'form-field-user'
            },
            name : {
                type : String,
                default : 'user'
            },
            value : {
                type : [String, Number],
                default : ''
            },
            placeholder : {
                type : String,
                default : ''
            },
            className : {
                type : String,
                default : ''
            },
            tabindex : {
                type : [String, Number],
                default : ''
            },
            isStatic : {
                type : Boolean,
                default : false
            },
            userType : {
                type : Number,
                default : ''
            },
            customerId : {
                type : [String, Number],
                default : ''
            },
            locationId : {
                type : Number,
                default : null
            }
        },
        data() {
            return {
                item    : {
                    profile : {
                        firstname   : '',
                        lastname    : ''
                    }
                },
                items   : []
            };
        },
        computed : {
            hasPlaceholder : function () {
                return this.placeholder !== '';
            }
        },
        created : function () {
            this.onUpdateItems();
        },
        watch : {
            value : function (newVal) {
                this.onSelectItem(newVal);
            },
            locationId : function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.onUpdateItems();
                }
            }
        },
        methods : {
            onUpdateItems : function () {
                let promise = this.$api.clearParams()
                    .addParam('usertype', this.userType)
                    .addParam('customer', this.customerId)
                    .addParam('location_id', this.locationId)
                    .addParam('active', 1)
                    .get('accounts');

                promise.then((response => {
                    this.items = response.data.data;
                }).bind(this)).catch((error => {
                    this.items = [];
                }).bind(this)).finally((() => {
                    if (this.value) {
                        this.onSelectItem(this.value);
                    }
                }).bind(this));
            },
            onSelectItem : function (id) {
                var item = this.getItemById(id);

                if (item) {
                    this.item = item;
                } else {
                    this.item = {
                        profile : {
                            firstname   : '',
                            lastname    : ''
                        }
                    };
                }

                this.$emit('input', id);
                this.$emit('change', item);
            },
            onChangeItem : function (event) {
                this.onSelectItem(parseInt(event.currentTarget.value));
            },
            getItemById : function (id) {
                var output = null;

                this.items.forEach((function (item) {
                    if (item.id === id) {
                        output = item;
                    }
                }).bind(this));

                return output;
            },
            isSelectedItem : function (id) {
                return parseInt(this.value) === parseInt(id);
            }
        }
    }
</script>